// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestRect {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    private _buttonList: vf.gui.Label[] = [];

    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {


        this.allG(uiStage);
    }

    private allG(uiStage: vf.gui.Stage) {

        const ds: vf.gui.DisplayObject[] = [];

        const rect = new vf.gui.Rect();
        rect.x = 400;
        rect.y = 10;
        rect.style.width = 200;
        rect.style.height = 200;
        rect.style.lineColor = [255, 0, 0, 1];
        rect.style.lineWidth = 1;
        rect.style.fillColor = [[255, 0, 0, 1],[0, 255, 0, 1]];
        rect.radius = 30; //圆角
        uiStage.addChild(rect);
        ds.push(rect);


        const isosceles = new vf.gui.Isosceles();
        isosceles.x = 400;
        isosceles.y = 220;
        isosceles.style.width = 200;
        isosceles.style.height = 300;
        isosceles.lineColor = 0xffffff;
        isosceles.lineWidth = 1;
        isosceles.upLine = 100;
        isosceles.downLine = 200;
        uiStage.addChild(isosceles);
        ds.push(isosceles);


        const arrow = new vf.gui.Arrow();
        arrow.x = 160;
        arrow.y = 130;
        arrow.width = 200;
        arrow.height = 80;
        arrow.lineColor = 0xff0000;
        arrow.lineWidth = 3;
        uiStage.addChild(arrow);
        ds.push(arrow);

        /** 绘制 */
        const circle = new vf.gui.Circle();
        circle.x = 450;
        circle.y = 530;
        circle.lineColor = 0xff00cc;
        circle.lineWidth = 3;
        circle.width = 100;
        uiStage.addChild(circle);
        ds.push(circle);

        const ellipse = new vf.gui.Ellipse();
        ellipse.lineType = "full";
        ellipse.x = 660;
        ellipse.y = 10;
        ellipse.lineColor = 0xffcc00;
        ellipse.lineWidth = 3;
        ellipse.width = 300;
        ellipse.height = 200;
        uiStage.addChild(ellipse);
        ds.push(ellipse);

        const slq = new vf.gui.Isosceles();
        slq.x = 130;
        slq.y = 220;
        slq.style.width = 199;
        slq.style.height = 200;
        slq.lineColor = 0xffffff;
        slq.lineWidth = 1;
        slq.upLine = 0;
        slq.downLine = 200;
        uiStage.addChild(slq);
        ds.push(slq);

        const star = new vf.gui.Star();
        star.x = 600;
        star.y = 300;
        star.lineColor = 0xff0000;
        star.lineWidth = 1;
        star.width = 100;
        star.height = 100;
        star.triangleNum = 5;
        uiStage.addChild(star);
        ds.push(star);

        const stars = new vf.gui.Star();
        stars.x = 750;
        stars.y = 300;
        stars.lineColor = 0x00ff00;
        stars.lineWidth = 1;
        stars.width = 100;
        stars.height = 100;
        stars.triangleNum = 10;
        uiStage.addChild(stars);
        ds.push(stars);

        const basicText = new vf.gui.Label();
        basicText.width = 300;
        basicText.x = 30;
        basicText.y = 10;
        basicText.style.fontSize = 30;
        basicText.text = "渐变色,渐变色,渐变色";
        uiStage.addChild(basicText);
        ds.push(basicText);

        const stroke = new vf.gui.Label();
        stroke.width = 300;
        stroke.x = 0;
        stroke.y = 60;
        stroke.style.fontSize = 80;
        stroke.style.fillColor = [];
        stroke.style.strokeThickness = 1; // 描边宽度
        stroke.style.stroke = [78, 110, 242, 1]; // 设置文字描边颜色
        stroke.text = "空心字";
        uiStage.addChild(stroke);


        ds.forEach((display: vf.gui.DisplayObject) => {

            // 0垂直，1水平
            display.style.fillGradientType = Math.round(Math.random()) as 0 | 1;
            // 渐变分布位置
            display.style.fillGradientStops = [0, 0.5, 0.5];
            // 填充RGBA数组，二维
            display.style.fillColor = [
                this.getRandomRGBA(), // [r,g,b,a]
                this.getRandomRGBA(), // [r,g,b,a]
                this.getRandomRGBA(), // [r,g,b,a]
                this.getRandomRGBA()  // [r,g,b,a]
            ];
        });

        let index = Math.random();
        vf.gui.Scheduler.setInterval(60, () => {
            ds.forEach((value: vf.gui.DisplayObject) => {
                if (index > 1) {
                    index = 0;
                } else {
                    index = index + 0.01;
                }
                value.style.fillGradientStops = [0, 0.5, 0.5, Math.min(1, index)] // 渐变分布位置
            });
        })
    }

    private getRandomRGBA() {
        const r = Math.ceil(Math.random() * 255);
        const g = Math.ceil(Math.random() * 255);
        const b = Math.ceil(Math.random() * 255);
        const a = 1;//Math.random();
        return [r, g, b, a];
    }

    private posY = 15;
    private getButton(title: string, clickFun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 30;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, clickFun);
        target.addChild(button);
        this.posY = this.posY + 30 + y;
        this._buttonList.push(button);
        return button;
    }

}
